import { configureStore } from "@reduxjs/toolkit";
// import { interceptor } from "../common/cticApi";
import authLoginSlice from "./auth/authLoginSlice";
import lawFirmSlice from "./lawFirm/lawFirmSlice";
import languageSlice from "./language/languageSlice";
import forgotPasswordSlice from "./auth/forgotPasswordSlice";
import changePasswordSlice from "./auth/changePasswordSlice";
import resetPasswordSlice from "./auth/resetPasswordSlice";
import quickRegisterSlice from "./Registration/quickRegisterSlice";
import registrationSlice from "./Registration/registrationSlice";
import orderLawyerInformationSlice from "./auth/orderLawyerInformationSlice";
import orderSlice from "./orders/orderSlice";
import orderSummarySlice from "./ordersSummary/orderSummarySlice";
import idleSlice from "./auth/idleSlice";
import unifiedQuestionSlice from "./unifiedQuestions/unifiedQuestionSlice";
import { interceptor } from "../common/cticApi";
import lenderSlice from "./lenders/lenderSlice";
import viewOrderSlice from "./orders/viewOrderSlice";
import notesSlice from "./notes/notesSlice";
import uploadDocumentSlice from "./uploadDocument/uploadDocumentSlice";
import profileSlice from "./profile/profileSlice";
import additionalInfoSlice from "./additionalInfo/additionalInfoSlice";
import notificationSlice from "./notification/notificationSlice";
import manageBillingSlice from "./managebilling/manageBillingSlice";
import requiredDocumentSlice from "./requiredDocument/requiredDocumentSlice";
import quoteSlice from "./quote/quoteSlice";
import iDVerificationPageSlice from "./IDVerificationPage/idVerificationPageSlice";
import secureLoginSlice from "./secureLogin/secureLoginSlice";
import dashboardSlice from "./dashboard/dashboardSlice";
import cancelOrderSlice from "./orders/cancelOrderSlice";
import invoiceSlice from "./invoice/invoiceSlice";

// This is where we configure our redux store and keep all our redux slices.
// Each slice contains indivisual global state for each usecase.
// This configureStore combines all the redux slices to form a store.

const store = configureStore({
  reducer: {
    language: languageSlice,
    authLogin: authLoginSlice,
    lawFirm: lawFirmSlice,
    forgotPassword: forgotPasswordSlice,
    changePassword: changePasswordSlice,
    resetPassword: resetPasswordSlice,
    quickRegister: quickRegisterSlice,
    registration: registrationSlice,
    orderLawyerInfo: orderLawyerInformationSlice,
    ordersSlice: orderSlice,
    orderSummary: orderSummarySlice,
    // idle: idleSlice,
    unifiedQuestions: unifiedQuestionSlice,
    lenders: lenderSlice,
    viewOrders: viewOrderSlice,
    notes: notesSlice,
    uploadDocument: uploadDocumentSlice,
    profile: profileSlice,
    additionalInfo: additionalInfoSlice,
    notification: notificationSlice,
    manageBilling: manageBillingSlice,
    requiredDocument: requiredDocumentSlice,
    quote: quoteSlice,
    idVerificationPage: iDVerificationPageSlice,
    secureLogin: secureLoginSlice,
    dashboard: dashboardSlice,
    cancelOrder:cancelOrderSlice,
    invoice:invoiceSlice,
  },
});
interceptor(store);
export default store;
